import { render, staticRenderFns } from "./ModalPurchaseExpenses.vue?vue&type=template&id=fdebd00a&"
import script from "./ModalPurchaseExpenses.vue?vue&type=script&lang=js&"
export * from "./ModalPurchaseExpenses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports